import React from 'react'
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { StatusChip } from 'src/components/payments-ops/StatusChip'
import {
  paymentReviewReasonLabels,
  paymentReviewStatusLabels,
  partnerDriverPaymentStatusLabels,
} from 'src/constants/payments-ops/labels'
import type {
  PartnerDriverPaymentStatus,
  PaymentReviewReason,
  PaymentReviewStatus,
} from 'src/constants/payments-ops/enums'
import type { StatusLabel } from 'src/constants/payments-ops/types'
import type { OtherEarning } from 'src/interfaces/paymentsReview'
import { formatDateTime, parseUnixTimestamp } from 'src/utils/grid'
import { formatCentsAsUsd } from 'src/utils/invoiceMoney'

const renderLabel = (label?: StatusLabel) => {
  if (!label) {
    return <span>—</span>
  }

  return <StatusChip label={label.label} tone={label.tone} />
}

export const otherEarningsColumns: Array<GridColDef<OtherEarning>> = [
  {
    field: 'createdAt',
    headerName: 'Created at',
    width: 180,
    valueGetter: parseUnixTimestamp,
    valueFormatter: formatDateTime,
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    valueFormatter: (value: number) => {
      return formatCentsAsUsd(value)
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    minWidth: 150,
    display: 'flex',
    renderCell: (params: GridRenderCellParams<OtherEarning, PartnerDriverPaymentStatus>) => {
      return renderLabel(params.value ? partnerDriverPaymentStatusLabels[params.value] : undefined)
    },
  },
  {
    field: 'reviewStatus',
    headerName: 'Review status',
    flex: 1,
    minWidth: 150,
    display: 'flex',
    renderCell: (params: GridRenderCellParams<OtherEarning, PaymentReviewStatus | null>) => {
      return renderLabel(params.value ? paymentReviewStatusLabels[params.value] : undefined)
    },
  },
  {
    field: 'reviewReason',
    headerName: 'Review reason',
    flex: 1,
    minWidth: 150,
    display: 'flex',
    renderCell: (params: GridRenderCellParams<OtherEarning, PaymentReviewReason | null>) => {
      return renderLabel(params.value ? paymentReviewReasonLabels[params.value] : undefined)
    },
  },
]
